/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
import { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useSelector, useDispatch } from 'react-redux';
import { LoadVendorsRequest } from '../../../../features/Vendor/VendorSlice';
import API from '../../../../Services/API';
import { loaderActions } from '../../../../features/Loader/LoaderSlice';
import { AllCompanyIDs } from '../../../../components/shared/Company';

function UserForm(props) {
  const dispatch = useDispatch();

  const { vendorList } = useSelector((state) => state.vendor);

  const [user, setUser] = useState({
    email: '',
    role: props.role,
    password: '',
    vendorsList: []
  });

  const [passwordType, setPasswordType] = useState('password');
  const roleOptions = [
    { label: 'EVP Super Admin', value: 'admin' },
    { label: 'Senior Team Lead', value: 'senior-team-lead' },
    { label: 'Team Lead', value: 'team-lead' },
    { label: 'Supervisor', value: 'supervisor' },
    { label: 'Manager', value: 'manager' }
  ];

  const animatedComponents = makeAnimated();

  let modalHeader;
  let actionButton;
  let accessSelectors;

  if (user.role === 'supervisor') {
    accessSelectors = (
      <Form.Group controlId="vendors">
        <Form.Label>Vendors</Form.Label>
        <Select
          components={animatedComponents}
          options={vendorList}
          isSearchable={true}
          isMulti
          value={user.vendorsList}
          onChange={(e) => {
            setUser({ ...user, vendorsList: e });
          }}
        />
        <Form.Text className="text-muted">Leave Empty for access to All Vendors</Form.Text>
      </Form.Group>
    );
  } else if (user.role === 'senior-team-lead' || user.role === 'team-lead') {
    accessSelectors = (
      <Form.Group controlId="vendors">
        <Form.Label>Vendors</Form.Label>
        <Select
          components={animatedComponents}
          options={vendorList}
          isSearchable={true}
          isMulti
          value={user.vendorsList}
          onChange={(e) => {
            setUser({ ...user, vendorsList: e });
          }}
        />
        <Form.Text className="text-muted">Leave Empty for access to All Vendors</Form.Text>
      </Form.Group>
    );
  } else if (user.role === 'manager') {
    accessSelectors = (
      <>
        <Form.Group controlId="vendors">
          <Form.Label>Vendors</Form.Label>
          <Select
            components={animatedComponents}
            options={vendorList}
            isSearchable={true}
            value={user.vendorsList}
            onChange={(e) => {
              setUser({ ...user, vendorsList: [e] });
            }}
          />
        </Form.Group>
      </>
    );
  } else {
    accessSelectors = <></>;
  }

  useEffect(() => {
    async function init() {
      const companyIds = AllCompanyIDs;
      await companyIds.forEach((companyId, idx) =>
        dispatch(
          LoadVendorsRequest({
            type: 'all_vendors',
            companyId
          })
        )
      );
    }
    init();

    if (props.modalStatus === 'new') {
      setUser({
        email: '',
        password: '',
        role: props.role,
        vendorsList: []
      });
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show === true && props.modalStatus === 'edit') {
      if (props.role === 'admin') {
        setUser({
          email: props.user.email,
          password: '',
          role: props.role,
          vendorsList: []
        });
      } else {
        let vendorsList = [];
        if (Array.isArray(props.user.vendor)) {
          const userVendors = props.user.vendor.map((v) => `${v.code}-${v.name}`);
          vendorsList = vendorList.filter((vendor) => userVendors.includes(vendor.value));
        }
        setUser({
          email: props.user.email,
          password: '',
          role: props.role,
          vendorsList
        });
      }
    }
  }, [props.show, props.modalStatus]);

  if (props.modalStatus && props.modalStatus === 'new') {
    modalHeader = <Modal.Title id="contained-modal-title-vcenter">Add New User</Modal.Title>;
    actionButton = (
      <Button onClick={CreateAdminUser} variant="success">
        Save
      </Button>
    );
  } else {
    modalHeader = <Modal.Title id="contained-modal-title-vcenter">Edit User</Modal.Title>;
    actionButton = <Button onClick={UpdateAdminUser}>Update</Button>;
  }

  function togglePasswordType() {
    if (passwordType === 'password') {
      setPasswordType('text');
    } else {
      setPasswordType('password');
    }
  }

  async function CreateAdminUser() {
    if (!user.email || user.email.length <= 0) {
      toast.error('Please enter complete email address');
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        user.email
      )
    ) {
      toast.error('Please enter a valid email address');
    } else if (!user.password || user.password.length <= 0) {
      toast.error('Please enter a password');
    } else if (!/^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)/.test(user.password)) {
      toast.error('Please enter a valid password');
    } else if (!user.role || user.role.length <= 0) {
      toast.error('Please select a valid role');
    } else if (user.role === 'manager' && user.vendorsList === undefined) {
      toast.error(`Please assign vendors to ${user.role}`);
    } else {
      let vendors;
      if (
        user.role === 'manager' ||
        user.role === 'senior-team-lead' ||
        user.role === 'team-lead' ||
        (user.role === 'supervisor' && user.vendorsList.length > 0)
      ) {
        vendors = user.vendorsList.map((v) => {
          return {
            name: v.entity,
            code: v.vendNo
          };
        });
      } else {
        vendors = [];
      }
      try {
        dispatch(loaderActions.show());
        await API().post('/evp-users', {
          email: user.email,
          role: user.role,
          password: user.password.trim(),
          vendor: vendors
        });
        toast.success('User added successfully.');
        props.onHide('reload');
      } catch (err) {
        if (err.response) {
          if (err.response.data.includes('An account with the given email already exists')) {
            console.error('Error occured during user create\nError: ', err.response.data);
            toast.error('An account with the given email already exists.');
          } else {
            console.error('Error occured during user create\nError: ', err.response.data);
            toast.error(err.response.data);
          }
        } else {
          console.error('Error occured during brand user create process\nError: ', err);
          toast.error('Error occured during brand addition process');
        }
      } finally {
        dispatch(loaderActions.hide());
      }
    }
  }

  async function UpdateAdminUser() {
    if (!user.role || user.role.length <= 0) {
      toast.error('Please select a valid role');
    } else if (user.role === 'manager' && user.vendorsList.length === 0) {
      toast.error(`Please assign vendors to ${user.role}`);
    } else {
      let vendors;
      if (
        (user.role === 'supervisor' && user.vendorsList.length > 0) ||
        user.role === 'manager' ||
        user.role === 'senior-team-lead' ||
        user.role === 'team-lead'
      ) {
        vendors = user.vendorsList.map((v) => {
          return {
            name: v.entity,
            code: v.vendNo
          };
        });
      } else {
        vendors = [];
      }
      try {
        dispatch(loaderActions.show());
        await API().patch(`/evp-users/${user.email}`, {
          role: user.role,
          vendor: vendors
        });
        toast.success('User updated successfully.');
        props.onHide('reload');
      } catch (err) {
        if (err.response) {
          if (err.response.data.includes('An account with the given email already exists')) {
            console.error('Error occured during user create\nError: ', err.response.data);
            toast.error('An account with the given email already exists.');
          } else {
            console.error('Error occured during user create\nError: ', err.response.data);
            toast.error(err.response.data);
          }
        } else {
          console.error('Error occured during brand user create process\nError: ', err);
          toast.error('Error occured during brand addition process');
        }
      } finally {
        dispatch(loaderActions.hide());
      }
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>{modalHeader}</Modal.Header>
      <Modal.Body>
        <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email Address"
            value={user.email}
            readOnly={props.modalStatus === 'edit'}
            onChange={(e) => {
              setUser({ ...user, email: e.target.value });
            }}
          />
        </Form.Group>
        {props.modalStatus === 'new' ? (
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <InputGroup className="mb-3">
              <br />
              <Form.Control
                type={passwordType}
                placeholder="Login Password"
                value={user.password}
                onChange={(e) => {
                  setUser({ ...user, password: e.target.value });
                }}
              />
              <InputGroup.Append>
                <InputGroup.Text onClick={togglePasswordType}>
                  <i
                    className={
                      passwordType === 'password' ? 'feather icon-eye-off' : 'feather icon-eye'
                    }
                  ></i>
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
            <Form.Text className="text-muted">
              Must be at least 8 characters long with 1 uppercase 1 lowercase 1 numeric and 1
              special character.
            </Form.Text>
          </Form.Group>
        ) : (
          <></>
        )}

        <Form.Group controlId="role">
          <Form.Label>Role</Form.Label>
          <Select
            components={animatedComponents}
            options={roleOptions}
            value={roleOptions.find((role) => role.value === user.role)}
            onChange={(e) => {
              setUser({ ...user, role: e.value });
            }}
          />
        </Form.Group>
        {accessSelectors}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="danger">
          Close
        </Button>
        {actionButton}
      </Modal.Footer>
    </Modal>
  );
}

export default UserForm;
